/* User defined models */
import { PoliticalUnit } from './politicalUnit';


export class Country extends PoliticalUnit {
  children: string;
  phonePrefix: string;
  provinceCount: number;

  constructor(apiObject: any) {
    super(apiObject.id, apiObject.name, apiObject.uri || apiObject.href);
    this.phonePrefix = apiObject.phonePrefix;
    this.provinceCount = apiObject.provinceCount;
  }
}
